<template>
  <div class="task-tags">
    <div v-if="tags & 1" class="task-tag is-kaiting">开庭</div>
  </div>
</template>

<script>
export default {
  name: 'TaskTags',
  props: {
    tags: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.task-tags {
  display: inline-block;
  .task-tag {
    display: inline-block;
    width: max-content;
    vertical-align: middle;
    height: 16px;
    padding-inline: 4px;
    border-radius: 3px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 16px;
  }
  .is-kaiting {
    color: #3378FF;
    background: #EFF5FF;
    border: .5px solid #C9DCFF;
  }
}
</style>
